<template>
	<div>
<!--Page de login - Authentification--------------------------------------------------------------------------------------------------------------------------------------------------------->						

	<Authentification/>		

<!--Page d'accueil--------------------------------------------------------------------------------------------------------------------------------------------------------->						

		<v-flex	xs12 md12 v-if="$store.state.authenticated">
			<v-container grid-list-md text-center>
				<v-layout wrap v-if="$store.state.mainPageActive">
					<v-flex xs12 sm6>
						<v-card
							color="#4586BB"
							theme="dark"
							class="white--text"
						>
							<div class="d-flex flex-no-wrap justify-space-between">
								<div>
									<v-card-title class="text-h5">
										SolarTool
									</v-card-title>

									<v-card-subtitle>Create ASW quotes and orders from designers files</v-card-subtitle>

									<v-card-actions>
									<v-btn
										class="ms-2"
										variant="outlined"
										size="small"
										@click= "solarToolActive"
									>
										SolarTool
									</v-btn>
									</v-card-actions>
								</div>
								<v-avatar
									class="ma-3"
									size="125"
									rounded="0"
								>
								<v-img src="@/assets/solartool.jpg"></v-img>
							</v-avatar>
							</div>
						</v-card>
					</v-flex>
					<v-flex xs12 sm6>
						<v-card
							color="#4586BB"
							theme="dark"
							class="white--text"
						>
							<div class="d-flex flex-no-wrap justify-space-between">
								<div>
									<v-card-title class="text-h5">
									Heat pumps & floor heating
									</v-card-title>

									<v-card-subtitle>Atlantic Alféa / RBM Kilma</v-card-subtitle>

									<v-card-actions>
									<v-btn
										class="ms-2"
										variant="outlined"
										size="small"
										:disabled= true
									>
										REXEL ME
									</v-btn>
									</v-card-actions>
								</div>

								<v-avatar
									class="ma-3"
									size="125"
									rounded="0"
								>
									<v-img src="@/assets/hpfh.jpg"></v-img>
								</v-avatar>
							</div>
						</v-card>
					</v-flex>
					<v-flex xs12 sm6>
						<v-card
							color="#4586BB"
							theme="dark"
							class="white--text"
							:disabled="!$store.state.authenticatedAdmin"
						>
							<div class="d-flex flex-no-wrap justify-space-between">
								<div>
									<v-card-title class="text-h5">
										SolarTool Database
									</v-card-title>

									<v-card-subtitle>Manage Solartool database</v-card-subtitle>

									<v-card-actions>
										<v-btn
											class="ms-2"
											variant="outlined"
											size="small"
											@click="solarToolDbActive"
											:disabled= true
										>
											SolarTool database
										</v-btn>
									</v-card-actions>
								</div>

								<v-avatar
									class="ma-3"
									size="125"
									rounded="0"
								>
									<v-img src="@/assets/solartooldatabase.png"></v-img>
								</v-avatar>
							</div>
						</v-card>
					</v-flex>
					<v-flex xs12 sm6>
						<v-card
							color="#4586BB"
							theme="dark"
							class="white--text"
							:disabled="!$store.state.authenticatedAdmin"
						>
							<div class="d-flex flex-no-wrap justify-space-between">
								<div>
									<v-card-title class="text-h5">
										ASW Database Update
									</v-card-title>

									<v-card-subtitle>Update database from ASW export files</v-card-subtitle>

									<v-card-actions>
									<v-btn
										class="ms-2"
										variant="outlined"
										size="small"
										:disabled= true
									>
										ASW database
									</v-btn>
									</v-card-actions>
								</div>

								<v-avatar
									class="ma-3"
									size="125"
									rounded="0"
								>
									<v-img src="@/assets/database.png"></v-img>
								</v-avatar>
							</div>
						</v-card>
					</v-flex>
				</v-layout>
				
<!--SolarTool--------------------------------------------------------------------------------------------------------------------------------------------------------->						
				
				<PageSolarTool/>

<!--Fin page d'accueil--------------------------------------------------------------------------------------------------------------------------------------------------------->						

			</v-container>
		</v-flex>
	</div>

</template>

<!--Scripts--------------------------------------------------------------------------------------------------------------------------------------------------------->						

<script>
	import axios from 'axios';
	import Authentification from './Authentification.vue';
	import ToolBoxMixins from './mixins/ToolBoxMixins.js';
	import PageSolarTool from './PageSolarTool.vue';

	export default {
		name: "PageAccueil",
		mixins: [
			ToolBoxMixins,
		],
		components: {
			Authentification,
			PageSolarTool,
		},
		data: function () {
			return {
				axios_error: "",
                attachment_oversize_text: "",
			};
		},
		created() {
			axios.interceptors.request.use((config) => {
				this.setLoading(true);
				return config;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});
			axios.interceptors.response.use((response) => {
				this.setLoading(false);
				return response;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});
		},
		mounted() {
		},
		methods: {
			solarToolActive: function () {
                this.$store.state.mainPageActive = false;
                this.$store.state.pageSolarToolActive = true;
                this.$store.state.pageSolarToolMainActive = true;
                this.$store.state.pageSolarToolOptionsActive = false;
                this.$store.state.pageSolarToolResultsActive = false;
				this.$store.state.pageSolarToolDbActive = false;
            },
			solarToolDbActive: function () {
                this.$store.state.mainPageActive = false;
                this.$store.state.pageSolarToolActive = false;
				this.$store.state.pageSolarToolDbActive = true;
            },
			setLoading(temp_state) {
				if (temp_state) {
					this.$store.state.is_loading = true;
				}
				else {
					this.$store.state.is_loading = false;
				}
			},
		},
	}

</script>

<style>
	h2 {
		margin: 10px;
	}
	.progress {
		margin-top: 1px;
	}
	.cardWrapper {
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}
	.table-bordered {
		border-collapse: collapse;
	}
	.table-bordered {
		border: 1px solid black;
	}
	.th-bordered {
		border: 1px solid black;
	}
	.td-bordered {
		border: 1px solid black;
	}
	tr:hover {background-color: #f5f5f5;}
</style>
